import { render, staticRenderFns } from "./RiepilogoModifiche.vue?vue&type=template&id=428be009&scoped=true"
import script from "./RiepilogoModifiche.vue?vue&type=script&lang=js"
export * from "./RiepilogoModifiche.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428be009",
  null
  
)

export default component.exports